import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsEmailHotAlertCheckUpdate } from "store/actions"
import * as Alert from "alertService"
import Auth from "auth"
import Lng from "language"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"
import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import { arrayObject } from "ConvertKey"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import EventNoteIcons from "@material-ui/icons/EventNote"
import FormLabel from "@material-ui/core/FormLabel"

// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
}

var userCode = Auth.getUserData()
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusWaitingUpdate: true,
      dataListRaw: [],
      dataList: [],

      currentSettingId: "",
      dataListSetting: [],
      dataTableList: [],
      currentBranchName: [],
      dataDealer: [],
      currentQuarterList: [],
      quarterList: [
        {
          label: "ไตรมาสที่ 2",
          value: 2,
        },
        {
          label: "ไตรมาสที่ 3",
          value: 3,
        },
        {
          label: "ไตรมาสที่ 4",
          value: 4,
        },
        {
          label: "ไตรมาสที่ 1",
          value: 1,
        },
      ]
    }
  }
  componentDidMount() {
    Alert.Loading(true)
    this.loadDealerDataList(() => {
      this.props.listsEmailHotAlertCheckUpdate(this.props.modeName, this.state.currentBranchName, this.state.currentQuarterList)
    })

  }
  componentWillUpdate(nextProps, nextState) {

    if (nextProps.listsEmailHotAlertCheck !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps.listsEmailHotAlertCheck)
      this.setState({
        statusWaitingUpdate: false,
        dataListRaw: nextProps.listsEmailHotAlertCheck,
        dataList: dataList
      }, () => {
        if (this.props.id != ":id") {
          var c_data_active = null
          nextProps.listsEmailHotAlertCheck.map((data) => {
            if (this.props.id == data.lead_id._id) {
              c_data_active = data
            }
          })
          if (c_data_active) {
            this.props.callbacksetTabIndex(1)
            this.props.callbackSetCurrentData(c_data_active)

          }
        }
        Alert.LoadingClose()
      })
    }
  }

  loadDealerDataList = (callback) => {
    APIPost(UrlServer.URL_POST_GET_DEALER, { dealer_code: userCode.dealer_code }, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "dealer_code",
          newKey: "value"
        },
        {
          oldKey: "branch_name",
          newKey: "label"
        }
      ]
      )
      this.setState({
        dataDealer: newConvertDatas
      }, () => {
        callback()
      });
    })
  }

  handleChange = name => event => {

    this.setState({
      [name]: event.target.value
    })
  }

  renderListData = data => {
    return data.map((CData, key) => {
      return {
        id: (key + 1),
        quarter: (CData.lead_id) ? CData.lead_id.quarter_number : "-",
        first_name: CData.lead_id ? CData.lead_id.first_name : "-",
        last_name: CData.lead_id ? CData.lead_id.last_name : "-",
        tel: CData.lead_id ? CData.lead_id.tel : "-",
        send_sms_date: (CData.lead_id && CData.lead_id.send_sms_date) ? ISOToDateYMD(CData.lead_id.send_sms_date) : "",
        sms_expired_date: (CData.lead_id && CData.lead_id.sms_expired_date) ? ISOToDateYMD(CData.lead_id.sms_expired_date) : "",
        actions: (
          <div className="actions-right">
            {
              (
                true
                // userCode.user_type_code != 2
              ) ?
                <Button
                  round
                  onClick={() => this.handleViewDetail(key)
                  }
                  color="info"
                  className="remove"
                >
                  <div><EventNoteIcons /> จัดการ</div>
                </Button>
                : ""
            }

          </div>
        )
      }
    })
  }
  handleChangeAutoComplete = name => value => {
    this.setState({
      [name]: value,
    }, () => {
      if (name == "currentBranchName" || name == "currentQuarterList") {
        Alert.Loading(true)
        this.props.listsEmailHotAlertCheckUpdate(this.props.modeName, this.state.currentBranchName, this.state.currentQuarterList)
      }
    });
  };
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  handleViewDetail = (indexData) => {
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }
  render() {
    const { classes } = this.props
    const userData = Auth.getUserData()
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{Lng.ts("รายการลูกค้าที่ตอบคำถามและให้คะแนนต่ำกว่าเกณฑ์")}</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        {
                          (
                            userData.user_type_code != 4
                          ) ?
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer >
                                <GridItem xs={12} sm={12} md={12}>
                                  {
                                    (this.state.dataDealer.length > 0) ?
                                      <Autocomplete
                                        handleChange={this.handleChangeAutoComplete}
                                        value={this.state.currentBranchName}
                                        dataList={this.state.dataDealer}
                                        multi
                                        id="currentBranchName"
                                        label="เลือกสาขา"
                                      />
                                      : ""
                                  }
                                  <br />
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            : ""
                        }
                        <GridItem xs={12} sm={12} md={12}>
                          <GridContainer >
                            <GridItem xs={12} sm={12} md={12}>
                              <Autocomplete
                                handleChange={this.handleChangeAutoComplete}
                                value={this.state.currentQuarterList}
                                dataList={this.state.quarterList}
                                multi
                                id="currentQuarterList"
                                label="เลือกไตรมาส"
                              />
                              <br />
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
                {/* <GridContainer className="GridContainer-lm001">
                  <GridItem xs={12} sm={12} md={3} lg={3}>
                    <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                      ชื่อข้อมูล Lead ที่นำเข้า
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6} lg={6}>
                    {
                      (this.state.dataListSetting.length > 0) ?
                        <Select
                          value={this.state.currentSettingId}
                          listData={this.state.dataListSetting}
                          onChange={this.handleChangeState("currentSettingId")}
                        />
                      : ""
                    }
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3} lg={3}>
                    <Button
                      round
                      color="info"
                      className="Button-001"
                      onClick={this.handleDonwloadImportID}
                      fullWidth={true}
                    >
                      <CloudDownloadIcon className={classes.icons} />
                       แสดงข้อมูล
                    </Button>
                  </GridItem>
                </GridContainer> */}
                <span>จำนวน {thaiBath(this.state.dataList.length, false)} รายการ</span>
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "id",
                      width: 70
                    },
                    {
                      Header: "ไตรมาส",
                      accessor: "quarter"
                    },
                    {
                      Header: "ชื่อ",
                      accessor: "first_name"
                    },
                    {
                      Header: "สกุล",
                      accessor: "last_name"
                    },
                    {
                      Header: "เบอร์ติดต่อ",
                      accessor: "tel"
                    },
                    {
                      Header: "วันที่ตั้งส่ง SMS",
                      accessor: "send_sms_date"
                    },
                    {
                      Header: "วันที่ sms หมดอายุ",
                      accessor: "sms_expired_date",
                      width: 170
                    },
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      width: 200
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsEmailHotAlertCheck }) {
  return {
    listsEmailHotAlertCheck: listsEmailHotAlertCheck
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsEmailHotAlertCheckUpdate }
  )
)(UserFromImportListManagement)